import { forwardRef } from 'react';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * HOC to provide the useMapTokenPropsToCSS hook to a class component.
 * @param WrappedComponent - The component to provide token props support to.
 * @returns A new component that has token props support.
 */
export function withTokenProps(WrappedComponent) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  const ComponentWithTokenProps = /*#__PURE__*/forwardRef((props, ref) => {
    const {
      tokenProps
    } = filterProps(props);
    const cssProps = useMapTokenPropsToCSS(tokenProps);
    const componentProps = Object.assign({}, props, {
      cssStyles: cssProps,
      ref
    });
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, componentProps));
  });
  ComponentWithTokenProps.displayName = `withTokenProps(${displayName})`;
  return ComponentWithTokenProps;
}